import { Box, IconButton, Tooltip } from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import { ContainerPage, TitlePage } from "components";
import { usePopup } from "hooks/usePopup";
import { useCallback, useEffect, useState } from "react";
import storageService from "services/storageService";
import { useDebaunce } from "utils";

import { SummaryStockTable } from "./components/SummaryStockTable";
import {
  MainContent,
  RefreshBtnContent,
  SearchContent,
  SearchInput
} from "./style";
export const SummaryStockSku = () => {
  const { addPopup } = usePopup();
  const [summaryStockData, setSummaryStockData] = useState([]);
  const [search, setSearch] = useState(null);
  const [loading, setLoading] = useState(false);
  const getInitData = useCallback(async () => {
    try {
      setLoading(true);
      setSummaryStockData([]);
      const params = {
        search
      };
      const { data } = await storageService.getStorageResumeSku(params);
      setSummaryStockData(data.results);
    } catch (error) {
      const errorMessage = error?.response?.data?.msg;
      addPopup({
        type: "error",
        title: "Erro ao carregar lotes",
        description: errorMessage
      });
    } finally {
      setLoading(false);
    }
  }, [search, addPopup]);

  function handleSearch(e) {
    const { value } = e.target;
    setSearch(value);
  }

  const debaunceSearch = useDebaunce({ fn: handleSearch, delay: 800 });

  useEffect(() => {
    getInitData();
  }, [getInitData]);

  return (
    <ContainerPage>
      <Box>
        <TitlePage>Estoque resumo por sku </TitlePage>
      </Box>
      <MainContent>
        <SearchContent>
          <SearchInput
            placeholder="Sku ou nome do sku"
            onChange={debaunceSearch}
          />
          <RefreshBtnContent>
            <Tooltip title="Atualizar" aria-label="Atualizar" color="primary">
              <IconButton onClick={() => getInitData()}>
                <RefreshIcon />
              </IconButton>
            </Tooltip>
          </RefreshBtnContent>
        </SearchContent>
        <SummaryStockTable stockData={summaryStockData} loading={loading} />
      </MainContent>
    </ContainerPage>
  );
};
